<template>
    <z-backForm :name="'back-rank-cycle'" :align="true" @save="saveSet" @cancel="backset" v-loading.fullscreen.lock="full_screenFlag">
        <!-- 基本设置 -->
        <div class="small-title">职级周期</div>
        <div class="back-item">
            <div class="back-title">起始月份</div>
            <div class="back-wrap">
                <el-select class="top-choose" rule="noVal" v-tar="sub.startMonth" v-model="sub.startMonth" placeholder="请选择">
                    <el-option v-for="item in 12" :key="item" :value="item" :label="`${item}月`">
                    </el-option>
                </el-select>
                <div class="tip">下一周期起始月份</div>
            </div>
        </div>
        <div class="back-item">
            <div class="back-title">周期间隔</div>
            <div class="back-wrap">
                <el-select class="top-choose" rule="noVal" v-tar="sub.type" v-model="sub.type" placeholder="请选择">
                    <el-option v-for="item in cycle_interval" :key="item.val" :value="item.val" :label="item.text">
                    </el-option>
                </el-select>
                <div class="tip">{{ sub.startMonth | cycleTip(sub.type) }}</div>
            </div>
        </div>
        <!-- 分配阶段 -->
        <div class="small-title">职级分配</div>
        <div class="back-item">
            <div class="back-title">分配时长</div>
            <div class="back-wrap">
                <el-input class="top-choose" rule="number cycle_day" v-arg="5" v-tar="sub.distribute_days" v-model="sub.distribute_days" >
                    <template slot="append">工作日</template>
                </el-input>
                <div class="tip">职级分配的持续时间</div>
            </div>
        </div>
    </z-backForm>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        data(){
            return{
                full_screenFlag:false,
                sub:{
                    startMonth:"",  //下周期起始月
                    type:"",  //周期间隔
                    distribute_days:"",  //分配时长
                },
            }
        },

        computed:{
            ...mapState(['cycle_interval']),   //周期间隔  option   
        },

        created(){
            this.getData();
        },

        methods:{
            getData(){
                let url = `api/clerk/cfg_promotion`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        let data = res.res_data;
                        let sub = this.sub;

                        sub.startMonth = data.promotionStartMonth;
                        sub.type = data.promotionDistributeType;
                        sub.distribute_days = data.promotionDistributeDays;
                        this.$form.init("back-rank-cycle");
                    }
                });
            },
            saveSet(){
                this.full_screenFlag = true;
                let sub = this.sub;
                let url = `api/admin/cfg_promotion`;
                this.$http.post(url,{
                    promotion_start_month:sub.startMonth,
                    promotion_distribute_type:sub.type,
                    promotion_distribute_days:sub.distribute_days,
                }).then(res=>{
                    if(res.status == 200){
                        this.getData();
                        this.successTip("保存成功");
                    }
                    this.full_screenFlag = false;
                }).catch(err=>{
                    this.full_screenFlag = false;
                    this.errorTip("出错了");
                });
            },
            backset(dataArr){
                this.getData();
            },
        }
    }
</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// rank-cycle.vue?4b56a20b